import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navLinks, siteName } from '@/mocks/site';
import SearchBox from './SearchBox';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors cursor-pointer ${
      isActive
        ? 'text-accent-600 font-semibold'
        : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex flex-shrink-0 items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              {siteName}
            </span>
            <span className="hidden font-label text-[10px] tracking-widest text-foreground-500 sm:block">
              FILM &amp; SERIES
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink key={link.to} to={link.to} className={linkClass} end={link.to === '/'}>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBox />
        </div>

        <Link
          to="/search"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-secondary-100 lg:hidden cursor-pointer"
          aria-label="搜索"
        >
          <i className="ri-search-line text-xl" aria-hidden="true" />
        </Link>

        <button
          type="button"
          onClick={() => setMobileOpen((prev) => !prev)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-secondary-100 md:hidden cursor-pointer"
          aria-label="打开菜单"
          aria-expanded={mobileOpen}
        >
          <i className={mobileOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true" />
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="mb-4">
            <SearchBox />
          </div>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 font-label text-base transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-50 font-semibold text-primary-700'
                      : 'text-foreground-800 hover:bg-secondary-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}